import { ResolveResource } from './utils'
import Factory from './utils/Factory'
import fetch from '@/fetch'
const resource = ResolveResource(__filename)

export default new Factory(resource, {
  removeJob({ id, webhookId }) {
    return fetch(`/api/webhook/${webhookId}/job/${id}`, { method: 'DELETE' })
  },
})
